// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type PriceFragment = {
    readonly __typename?: 'Price';
    readonly currency: Types.Currency;
    readonly amount: number;
    readonly amountInMajor: number;
    readonly forHumans: string;
};

export const PriceFragmentDoc = gql`
    fragment price on Price {
        currency
        amount
        amountInMajor
        forHumans
    }
` as unknown as DocumentNode<PriceFragment, unknown>;
